<template>
  <div class="sm:self-center w-full sm:w-auto flex flex-col items-center">
    <h1 class="text-2xl">{{ t('langua.step_confirmation.title').slice(0, -1) }}<span class="inline-block w-0 text-gray-500">{{ t('langua.step_confirmation.title').slice(-1) }}</span></h1>
    <p class="mt-8 text-xl font-black">{{ verificationData.name }}</p>
    <p class="my-2 text-sm text-gray-500"><code>{{ verificationData.uuid }}</code></p>
    <skin-model width="160" height="240" :src="verificationData.url" :slim="verificationData.skinModel === 'alex'" />
    <div class="mt-8" style="max-width: 300px;">
      <mc-button type="primary" class="w-full" @click="$emit('forward')">{{ t('langua.step_confirmation.confirm_button_label') }}</mc-button>
      <hint-box type="tip" :content="t('langua.step_confirmation.hint_verification_will_change_skin')" class="mt-4" />
      <mc-button class="w-full mt-8" @click="$emit('backward')">{{ t('langua.step_confirmation.cancel_button_label') }}</mc-button>
    </div>
  </div>
</template>

<script>
  import SkinModel from '@/components/skin-model'
  import McButton from '@/components/mc-button.vue'
  import HintBox from '@/components/hint-box.vue'
  import useMelonAuth from '@/composables/melon-auth'
  import useI18n from '@/composables/i18n'

  export default {
    name: 'VerificationView',

    components: {
      SkinModel,
      McButton,
      HintBox,
    },

    setup () {
      let {verificationData} = useMelonAuth()
      const {t} = useI18n()

      return {
        verificationData,

        t,
      }
    },
  }
</script>

<style lang="scss" scoped>
  dl div {
    &:not(:first-child) {
      @apply border-t border-gray-200;
    }
  }

  dt {
    @apply pt-4 px-4 tracking-wide text-gray-500 uppercase;
  }

  dd {
    @apply px-4 pt-3 pb-4 overflow-auto text-xl;
  }
</style>
